/** Admin console tab ids (kept tiny: the route's search schema imports it). */
export const ADMIN_TABS = [
  'verifications',
  'reports',
  'land',
  'reviews',
  'registrations',
  'accounts',
  'privacy',
  'audit',
  'project',
  'sync',
] as const;
export type AdminTab = (typeof ADMIN_TABS)[number];
